import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class EnvService {
    public litaliaApiUrl = '';
    public environment = '';

    constructor() { }
}
